import React, { useState } from "react";
import { Button, Card, Divider, Form, message, Spin, Typography } from "antd";
import { PlusOutlined, FrownOutlined } from "@ant-design/icons";
import ExperienceModal from "./ExperienceModal";
import ExperienceCard from "./ExperienceCard";
import useCommonsService from "../../../../services/useCommonsService";
import usePersonnelInfoService from "../../../../services/usePersonnelInfoService";

const { Title, Text } = Typography;

const WorkExperience = ({ personnelExperience }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();
  const { useGetAllSectors, useGetAllPositions } = useCommonsService();
  const {
    useAddPersonnelExperience,
    useDeletePersonnelExperience,
    useUpdatePersonnelExperience,
  } = usePersonnelInfoService();
  const {
    mutateAsync: addPersonnelExperience,
    isPending: isExperienceAddLoading,
  } = useAddPersonnelExperience();
  const {
    mutateAsync: updatePersonnelExperience,
    isPending: isExperienceUpdateLoading,
  } = useUpdatePersonnelExperience();
  const {
    mutateAsync: deletePersonnelExperience,
    isPending: isExperienceDeleteLoading,
  } = useDeletePersonnelExperience();

  const { data: positions } = useGetAllPositions();
  const { data: sectors } = useGetAllSectors();
  const [editingExperience, setEditingExperience] = useState(null);

  const showModal = (experience = null) => {
    setEditingExperience(experience);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setEditingExperience(null);
  };

  const handleSave = async (values) => {
    try {
      await addPersonnelExperience(values);
      setIsModalVisible(false);
    } catch (error) {
      console.error("Add experience failed:", error);
    }
  };

  const handleEdit = async (values, id) => {
    try {
      await updatePersonnelExperience({ ...values, id });
      setIsModalVisible(false);
      setEditingExperience(null);
    } catch (error) {
      console.error("Update experience failed:", error);
    }
  };

  const handleDelete = (id) => {
    deletePersonnelExperience(id);
  };

  return (
    <Spin
      spinning={
        isExperienceAddLoading ||
        isExperienceDeleteLoading ||
        isExperienceUpdateLoading
      }>
      <div style={{ padding: "24px", paddingTop: 10 }}>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => showModal()}
          style={{ marginBottom: "10px" }}>
          İş Deneyimi Ekle
        </Button>

        <ExperienceModal
          visible={isModalVisible}
          onCancel={handleCancel}
          onSave={handleSave}
          onEdit={handleEdit}
          initialValues={editingExperience}
          sectors={sectors}
          positions={positions}
          form={form}
          isSubmitting={isExperienceAddLoading || isExperienceUpdateLoading}
        />
        {personnelExperience.length === 0 ? (
          <Card>
            <div style={{ textAlign: "center", padding: "20px" }}>
              <FrownOutlined style={{ fontSize: "48px", color: "#888" }} />
              <Title level={4}>Henüz eklenmiş hiç deneyiminiz yok</Title>
              <Text>
                Yukarıda yer alan <Text type="danger">"İş Deneyimi Ekle"</Text>{" "}
                butonunu kullanarak hemen yeni iş deneyimleri ekleyebilirsiniz
              </Text>
            </div>
          </Card>
        ) : (
          personnelExperience.map((exp) => (
            <ExperienceCard
              key={exp.id}
              experience={exp}
              onEdit={() => showModal(exp)}
              onDelete={() => handleDelete(exp.id)}
            />
          ))
        )}
      </div>
    </Spin>
  );
};

export default WorkExperience;
